<template>
    <div>
        <ValidationObserver ref="PointForm">
        <div class="row">
            <div class="col-12">
              <b-form-group :label="$t('grade')">
                  <b-row>
                      <b-col md="6" sm="12">
                          <ValidationProvider name="interview_exam_point" rules="required" v-slot="{ valid, errors }">
                              <b-form-input v-model="interview_exam_point" :disabled="!attended" :validationError="errors[0]"></b-form-input>
                              <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                          </ValidationProvider>
                      </b-col>
                      <b-col md="3" sm="6" class="mt-1">
                          <b-form-radio v-model="attended" :value="true">{{$t('yes')}}</b-form-radio>
                      </b-col>
                      <b-col md="3" sm="6" class="mt-1">
                          <b-form-radio v-model="attended" :value="false">{{$t('no')}}</b-form-radio>
                      </b-col>
                  </b-row>
              </b-form-group>
            </div>
            <div class="col-12">
                <b-button variant="primary" :disabled="!attended" @click="saveDate">{{$t('save')}}</b-button>
            </div>
        </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components

// Services
import GraduateApplicationService from "@/services/GraduateApplicationService";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        row: {
            type: Object
        },
    },
    data() {
        return {
            interview_exam_point: null,
            attended: null
        }
    },
    watch: {
        'row.interview_exam_point'(val){
            if(val) {
                this.interview_exam_point = val
                this.attended = true
            } else {
                this.interview_exam_point = null
                this.attended = null
            }
        }
    },
    created() {
        if(this.row && this.row.interview_exam_point) {
            this.interview_exam_point = this.row.interview_exam_point
            this.attended = true
        }
    },
    methods: {
        async saveDate(){
            const isValid = await this.$refs.PointForm.validate();
            if (isValid) {
                let formData = {
                    interview_exam_point: this.interview_exam_point
                }
                GraduateApplicationService.interviewPoint(this.row.perferenceId, formData).then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message))
                    this.$emit('close', true)
                }).catch(e => {
                    if (e.status == '404' || e.status == '406') {
                        if (e.data.message) {
                            this.$toast.error(this.$t('api.' + e.data.message));
                        }
                    }
                })
            }
        }
    }
}
</script>
